
import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";

const EstimationSpecificationReminderModal = ({
  title = "Reminder",
  message = "Please save your work.",
}) => {
  const [show, setShow] = useState(false);
  const timerIdRef = useRef(null);

  const startReminderTimer = () => {
    // clear old timer if any
    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current);
    }

    timerIdRef.current = setTimeout(() => {
      setShow(true);
      timerIdRef.current = null;
    }, 5* 60 * 1000); // 5 minutes
  };

  useEffect(() => {
    // start first 5‑minute wait when this component mounts
    startReminderTimer();

    return () => {
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
      }
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    startReminderTimer(); // start counting next 5 minutes
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0">{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EstimationSpecificationReminderModal;
